export function sortCategories(categories, { firstItems = [], lastItems = ['外星系列'] } = {}) {
  const set = new Set(categories)
  const middle = categories
    .filter((c) => !firstItems.includes(c) && !lastItems.includes(c))
    .sort()
  const first = firstItems.filter((c) => set.has(c))
  const last = lastItems.filter((c) => set.has(c))
  return [...first, ...middle, ...last]
}
